import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';

// Educational callout box that surfaces the legal doctrines behind a case.
// Each concept has a plain-English explanation and a link to the full
// glossary entry, doubling as (a) a trust-building expertise cue for readers
// and (b) internal linking to the glossary for SEO.
const LegalConceptsCallout = ({ title = 'Legal Concepts in This Case', concepts }) => {
  if (!concepts || concepts.length === 0) return null;

  return (
    <section className="py-12 md:py-16 bg-white" data-testid="legal-concepts-callout">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="bg-slate-50 border border-slate-100 rounded-2xl p-6 md:p-8">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 rounded-lg bg-teal-50 text-teal-700 flex items-center justify-center flex-shrink-0">
              <BookOpen className="w-5 h-5" aria-hidden="true" />
            </div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-secondary">
              {title}
            </h2>
          </div>

          <dl className="space-y-5">
            {concepts.map((c) => (
              <div key={c.term} data-testid={`legal-concept-${c.slug}`}>
                <dt className="font-semibold text-secondary mb-1 flex items-baseline gap-2 flex-wrap">
                  <span>{c.term}</span>
                  {c.latin && (
                    <span className="text-slate-400 italic text-sm font-normal">— {c.latin}</span>
                  )}
                </dt>
                <dd className="text-slate-700 leading-relaxed">
                  {c.explanation}{' '}
                  <Link
                    to={`/legal-glossary#${c.slug}`}
                    className="inline-flex items-center gap-1 text-teal-700 font-medium hover:underline whitespace-nowrap"
                    data-testid={`legal-concept-link-${c.slug}`}
                  >
                    See in glossary <ArrowRight className="w-3.5 h-3.5" />
                  </Link>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};

export default LegalConceptsCallout;
